import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';
import withGS from '../withGShoc';

class SnapshotConfigurationCard extends React.Component {

  selectConfiguration = () => this.props.onSelectConfiguration(this.props.configuration.id);

  render() {

    const { classes, data, isSelected, configuration } = this.props;
    const title = data && data.title ?
      data.title[data.defaultLang]
      :
      configuration.title ?
        configuration.title[Object.keys(configuration.title)[0]]
        :
        'Title not available';
    const defaultLang = data && data.defaultLang ?
      data.defaultLang
      :
      configuration.title ?
        Object.keys(configuration.title)[0]
        :
        '';

    return (
      <Card
        tabIndex={0}
        data-test={data.id}
        className={isSelected ? classes.gsSelectedCard : classes.gsCard}
        onKeyDown={(ev) => {
          if (ev.key === "Enter") {
            ev.preventDefault();
            ev.stopPropagation();
            this.selectConfiguration();
          }
        }}
        onClick={this.selectConfiguration}>
        <CardHeader
          data-test="configuration-name"
          classes={{
            root: classes.gsCardInner
          }}
          titleTypographyProps={{
            className: classes.gsCardHeader,
            "data-test": "list-project-title",
            "lang": defaultLang
          }}
          avatar={<Avatar
            data-test="list-avatar-language"
            className={defaultLang.length > 2 ? classes.wideSmallPrimaryAvatar : classes.smallPrimaryAvatar}
          >
            {defaultLang}
          </Avatar>
          }
          title={title}
        />
      </Card>
    );
  }
}

SnapshotConfigurationCard.defaultProps = {
  isSelected: false
};

SnapshotConfigurationCard.propTypes = {
  classes: PropTypes.object,
  isSelected: PropTypes.bool,
  configuration: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired,
  onSelectConfiguration: PropTypes.func.isRequired
};

export default withStyles(styles)(withGS(SnapshotConfigurationCard));